module.exports = __webpack_public_path__ + "img/supportsm__free-lp-creatives.6ee5967f.svg";